import { Container, Spacer, Tab, Tabs, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectOwnerName } from 'selectors/video';
import { clearLoginErrors } from 'utilities/auth';

import AnonCommentFooter from './anon-comment-footer';
import ShareSignIn from './share-signin';
import ShareSignUp from './share-signup';

export const SIGN_UP = 'Sign up';
export const SIGN_IN = 'Sign in';

const ShareSignupSignin = props => {
  const tabItems = [SIGN_UP, SIGN_IN];
  const { currentTab, setCurrentTab } = props;
  const ownerName = useSelector(selectOwnerName);

  return (
    <>
      <Text size="xlarge" fontWeight="bold">
        Sign up for free to learn when {ownerName} watches your video!
      </Text>

      <Spacer top={3}>
        <Tabs>
          {tabItems.map(tab => (
            <Tab
              key={tab}
              onClick={() => {
                setCurrentTab(tab);
                clearLoginErrors();
              }}
              isActive={currentTab === tab}
            >
              {tab}
            </Tab>
          ))}
        </Tabs>

        <Container>
          {currentTab === SIGN_UP && <ShareSignUp {...props} />}

          {currentTab === SIGN_IN && <ShareSignIn {...props} />}
        </Container>
      </Spacer>

      <AnonCommentFooter isFooter={true} />
    </>
  );
};

export default ShareSignupSignin;
